var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navigation',{attrs:{"mode":_vm.mode},on:{"setMode":_vm.setMode,"setContent":_vm.setContent}}),(_vm.mode === 'existing' && _vm.content === null)?_c('upload-file',{on:{"content":_vm.setContent}}):_vm._e(),(_vm.content !== null)?_c('edit-file',{attrs:{"content":_vm.content},on:{"setContent":_vm.setContent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }